import { Base64 } from 'js-base64'

export default class Requests {

  constructor (resource, backd) {
    this.resource = resource
    this.backd = backd
  }

  _getMany (page = 1, query = '', sort = '', perPage = 0, count = false) {
    var params = {
      'page': page,
      'per_page': perPage
    }

    // set default
    if (perPage === 0) {
      params['per_page'] = this.backd._options.per_page
    }

    if (sort !== '') {
      params['sort'] = sort
    }

    if (query !== '') {
      params['query'] = Base64.encode(query)
    }

    if (count === true) {
      params['count'] = 'true'
    }

    return this._getAll(params)
  }

  /**
   * Returns an object by its ID
   * @param {string} id     - ID of the object to query.
   * @param {object} params - Object with the required parameters to add to the URI.
   * @returns {object}      - Response object
   */
  _getOne (id, params = {}) {
    return this._make(
      'get',
      this._url(id),
      null,
      this._headerAuthorization(),
      params
    ).then(this._getData)
  }

  /**
   * Creates a new object on the remote endpoint
   * @param {object} model  - Model to save on the request.
   * @param {object} params - Object with the required parameters to add to the URI.
   * @returns {object}      - Response object
   */
  _create (model, params = {}) {
    return this._make(
      'post',
      this._url(),
      model,
      this._headerAuthorization(),
      params
    ).then(this._getData)
  }

  /**
   * Updates the selected model on the remote endpoint
   * @param {object} model  - Model to save on the request.
   * @param {object} params - Object with the required parameters to add to the URI.
   * @returns {object}      - Response object
   */
  _update (model, params = {}) {
    return this._make(
      'put',
      this._url(model._id),
      model,
      this._headerAuthorization(),
      params
    ).then(this._getData)
  }

  /**
   * Updates the selected url with the raw data passed without use any data from model
   * @param {string} url    - suffix to add to the class defined url.
   * @param {object} model  - Model to save on the request.
   * @param {object} params - Object with the required parameters to add to the URI.
   * @returns {object}      - Response object
   */
  _updateURL (url, model, params = {}) {
    return this._make(
      'put',
      this._url(url),
      model,
      this._headerAuthorization(),
      params
    ).then(this._getData)
  }

  /**
   * deletes an object by its ID
   * @param {string} id     - ID of the object to query.
   * @param {object} params - Object with the required parameters to add to the URI.
   * @returns {object}      - Response object
   */
  _delete (id, params = {}) {
    return this._make(
      'delete',
      this._url(id),
      null,
      this._headerAuthorization(),
      params
    )
  }

  /**
   * returns the required headers to the request based on the current data
   * at the main object
   * @returns {object} - Headers object
   */
  _headerAuthorization () {
    var headers = {}

    if (this.backd._security.token !== '') {
      headers['Authorization'] = 'Bearer ' + this.backd._security.token
    }

    return headers
  }

  /**
   * Returns the data from the request
   * @param {object} response - Response object
   * @returns {object}        - Data returned on the request
   */
  _getData (response) {
    return response.data ? response.data : {}
  }

  /**
   * Returns an array of objects at the given request. Params must be supply to modify
   * the search request.
   * @param {object} params - Object with the required parameters to add to the URI.
   * @returns {object}      - Response object
   */
  _getAll (params = {}) {
    return this._make(
      'get',
      this._url(),
      null,
      this._headerAuthorization(),
      params
    ).then(this._getData)
  }

  /**
   * Returns the data from the given relative uri determined by `path`.
   * @param {string} path   - Relative URI from the resource
   * @param {object} params - Object with the required parameters to add to the URI.
   * @returns {object}      - Response object
   */
  _getURL (path, params = {}) {
    return this._make(
      'get',
      this._url(path),
      null,
      this._headerAuthorization(),
      params
    ).then(this._getData)
  }

  /**
   * Makes the request to the server, if the current token is about to expire
   *   it will try to refresh it.
   * @param {string} method  - HTTP method
   * @param {string} url     - URL
   * @param {object} data    - Data to send in the request or null
   * @param {object} params  - Parameters to add to the request
   * @param {object} headers - Headers that needs to be included
   * @returns {object}       - Response object
   */
  _make (method, url, data = null, headers = {}, params = {}) {

    var that = this

    // uncomment for debug
    // console.log(this.backd.sessions().tokenTTL(), this.backd.sessions().tokenTTL() < 0 && this.backd.sessions().tokenTTL() > -1800)

    // if the TTL is less than 1800 seconds (30 minutes/50% token expiration) refresh it
    if (this.backd.sessions().tokenTTL() < 0 && this.backd.sessions().tokenTTL() > -1800) {
      return this.backd.sessions().refreshToken()
        .then(function (response) {
          return that.backd._axios({
            method,
            url,
            data,
            headers,
            params
          })
        })
    } else {
      return that.backd._axios({
        method,
        url,
        data,
        headers,
        params
      })
    }

  }

  _url (...parts) {
    parts.splice(0, 0, [this.backd._options['url'], this.resource].join('/'))
    return parts.join('/')
  }

}



// WEBPACK FOOTER //
// ./src/requests.js